import React from 'react'
import useAuth from '../hooks/useAuth.js'
import { Navigate } from 'react-router'

export const FallbackRoute = () => {
    const { isAuthenticated, isInitialized } = useAuth()

    if (!isInitialized) return null // TODO: Render DashboardLayout for better UX?

    if (!isAuthenticated) return <Navigate to='/auth/sign-in' />

    return <Navigate to='/404' />
}
